"use client";
import { useEffect } from "react";
import { Ticket } from "lucide-react";
import useCampaign from "@/app/lib/features/campaign/campaign.hook";
import CampaignCard from "@/app/components/common/campaigns/CampaignCard";
import CampaignsPageSkeleton from "@/app/components/elements/skeletons/CampaignsPageSkeleton";
import EmptyState from "@/app/components/elements/EmptyState";
import InfiniteScrollTrigger from "@/app/components/common/InfiniteScrollTrigger";

const CampaignsClient = () => {
  const {
    campaigns,
    campaignsPagination,
    isCampaignsIdle,
    isCampaignsLoading,
    isCampaignsError,
    hasMoreCampaigns,
    fetchCampaigns,
    fetchMoreCampaigns,
  } = useCampaign();

  useEffect(() => {
    if (isCampaignsIdle) {
      fetchCampaigns(1);
    }
  }, [isCampaignsIdle, fetchCampaigns]);

  const isInitialLoad = (isCampaignsIdle || isCampaignsLoading) && campaigns.length === 0;

  return (
    <div className="container-main py-6 sm:py-8">
      <div className="mb-6 sm:mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
          Kampanyalar
        </h1>
        {!isInitialLoad && !isCampaignsError && campaignsPagination && (
          <p className="text-sm text-gray-500 mt-1">
            {campaignsPagination.total} kampanya
          </p>
        )}
      </div>

      {isInitialLoad ? (
        <CampaignsPageSkeleton />
      ) : isCampaignsError ? (
        <EmptyState
          icon={Ticket}
          title="Kampanyalar yüklenemedi"
          description="Bir hata oluştu. Lütfen sayfayı yenileyip tekrar deneyin."
          actions={[{ label: "Tekrar Dene", onClick: () => fetchCampaigns(1) }]}
        />
      ) : campaigns.length === 0 ? (
        <EmptyState
          icon={Ticket}
          title="Henüz kampanya bulunmuyor"
          description="Şu an aktif kampanya yok. Daha sonra tekrar kontrol edin."
          actions={[{ label: "Anasayfaya Dön", href: "/", variant: "outline" as const }]}
        />
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
            {campaigns.map((campaign) => (
              <CampaignCard key={campaign.id} campaign={campaign} />
            ))}
          </div>
          <InfiniteScrollTrigger
            onLoadMore={fetchMoreCampaigns}
            hasMore={hasMoreCampaigns}
            isLoading={isCampaignsLoading}
          />
          {isCampaignsLoading && campaigns.length > 0 && (
            <div className="w-full py-8 flex justify-center">
              <div className="flex items-center gap-3 text-muted-foreground animate-fade-in">
                <div className="animate-spin rounded-full h-6 w-6 border-2 border-main border-t-transparent" />
                <span className="text-sm font-medium">
                  Daha fazla kampanya yükleniyor...
                </span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CampaignsClient;